import AuthService from 'services/auth.service';

const can = (allowedRoles = []) => {
	const user = AuthService.getCurrentUser();

	if (user?.role && allowedRoles.includes(user.role)) {
		return true;
	}
	return false;
}

export { can };
